export enum DocumentCodingType {
  Study = 1, // General
  InvestigativeSite = 2,
  Country = 3,
  Irb = 5, // not used and it's wrong because we have only 3 categories
  Organization = 6,
}
